import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
function useUpdateWorkspaceConfig() {
  return useMutation(function (_ref) {
    var workspaceId = _ref.workspaceId,
      data = _ref.data;
    return servicesUtils.patchService("/acr/config/".concat(workspaceId, "/"), data);
  });
}
export default useUpdateWorkspaceConfig;